/**
 * Form input wrapper with label and optional error.
 * Composable building block for derivative app forms.
 */
import type { ReactNode } from 'react'

import { Input } from '../ui/input'
import { Label } from '../ui/label'

export type FormFieldProps = {
  id?: string
  label: string
  error?: string
  children?: ReactNode
  /** When children omitted, renders a default input; pass input props via inputProps */
  inputProps?: React.ComponentProps<typeof Input>
  className?: string
}

export function FormField({
  id,
  label,
  error,
  children,
  inputProps,
  className,
}: FormFieldProps) {
  const fieldId = id ?? `field-${label.replace(/\s+/g, '-').toLowerCase()}`
  return (
    <div className={className}>
      <Label htmlFor={fieldId}>{label}</Label>
      {children != null ? (
        children
      ) : (
        <Input id={fieldId} {...inputProps} />
      )}
      {error != null && (
        <p className="text-sm text-destructive mt-1" role="alert">
          {error}
        </p>
      )}
    </div>
  )
}
